import PropTypes from 'prop-types';
import { ODSLoadingSpinner } from '@telekom-ods/react-ui-kit';
import { Grid } from '@mui/material';

const SpinnerLoader = ({
  isLoading,
  size = 'small',
  labelText,
  labelAlignment = 'vertical',
  children = null,
  height = '100%',
  width = '100%',
}) => {
  if (!isLoading) return children;
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ height, width }}
      data-testid="spinner-wrapper"
    >
      <ODSLoadingSpinner size={size} labelText={labelText} labelAlignment={labelAlignment} />
    </Grid>
  );
};

SpinnerLoader.propTypes = {
  labelText: PropTypes.string,
  labelAlignment: PropTypes.oneOf(['horizontal', 'vertical']),
  isLoading: PropTypes.bool.isRequired,
  size: PropTypes.oneOf(['small', 'large']),
  children: PropTypes.node,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default SpinnerLoader;
